import React from "react";
import { motion } from "framer-motion";
import { Play, RotateCw, Camera } from "lucide-react";

const REELS = [
  {
    src: "https://customer-assets.emergentagent.com/job_luxury-kingz-book/artifacts/zaj18rex_filtered-B5C2B86C-1E3E-43B5-A2D1-3ABE163882C9.mp4",
    label: "Classic Booth",
    icon: Camera,
  },
  {
    src: "https://customer-assets.emergentagent.com/job_luxury-kingz-book/artifacts/1o38nsto_20250524_190458403_fullSize.mp4",
    label: "360° Reel · 01",
    icon: RotateCw,
  },
  {
    src: "https://customer-assets.emergentagent.com/job_luxury-kingz-book/artifacts/fyo7e6l9_17-20241012-155758.508946-video.mp4",
    label: "360° Reel · 02",
    icon: RotateCw,
  },
];

export default function VideoShowcase() {
  return (
    <section
      id="showcase"
      data-testid="video-showcase"
      className="lk-section px-6 md:px-12 lg:px-24 bg-[#050505] relative overflow-hidden"
    >
      <div className="grid md:grid-cols-12 gap-8 mb-14 items-end">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 mb-4 text-[#D4AF37]">
            <Play className="w-4 h-4 fill-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase">In Motion</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">
            See the booth
            <br />
            <span className="italic gold-gradient-text">do its thing.</span>
          </h2>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <p className="text-zinc-400 leading-relaxed">
            Classic photo booth charm meets 360° cinematic motion. Slow-motion, music-synced, and instantly shareable —
            this is what your guests will be doing all night.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5 md:gap-6">
        {REELS.map((reel, i) => {
          const Icon = reel.icon;
          return (
            <motion.div
              key={reel.src}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="lk-card overflow-hidden group relative"
              data-testid={`showcase-video-${i}`}
            >
              <div className="aspect-[9/16] w-full bg-black relative">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  className="w-full h-full object-cover"
                >
                  <source src={reel.src} type="video/mp4" />
                </video>
                <div className="absolute top-4 left-4 flex items-center gap-2 bg-[#050505]/70 backdrop-blur-sm px-3 py-1.5 border border-[#D4AF37]/30">
                  <Icon className="w-3 h-3 text-[#D4AF37]" />
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{reel.label}</span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/40 via-transparent to-transparent pointer-events-none" />
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
